<template>
<div id="addFeedback">
  <v-form ref="feedbackForm">
     <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left @click="backToListing" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="-border">
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" to="/admin/feedbacks">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Submit</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
        <v-autocomplete
          v-model="feedbackData.account"
          :items="contactList"
          label="Family"
          :rules="familyRules"
          item-text="text"
          item-value="value"
          @change="changedData"
          class="required pr-4 pl-4">
        ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12 sm6 md7">
          <v-select @change="changedData" v-model="feedbackData.rating" :rules="ratingRules" :items="ratingOptions" label="Ratings" class="required pr-4 pl-4"></v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <div id="pageEditor" >
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex sm12>
                  <quill-editor
                    :content="content" 
                    :options="editorOption"
                    @input="changedData"
                    v-model="feedbackData.comment"
                  >
                  </quill-editor>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-flex>
      </v-layout>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container pr-3 text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/admin/feedbacks">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Submit</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
  </div>
</template>

<script>
/* global session store */
import swal from 'sweetalert2';
import { getCollection, create } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

// Admin can add feedbacks here
export default {
  name: 'AddFeedback',
  components: {
    quillEditor
  },
  data: () => ({
    feedbackData: {
      rating: '',
      comment: '',
      account: ''
    },
    selectedData: false,
    content: '',
    editorOption: {
      placeholder: 'Add Feeback Comment',
    },
    ratingRules: [
      v => !!v || 'Rating is required'
    ],
    familyRules: [
      v => !!v || 'Family is required'
    ],
    contactList: [],
    ratingOptions: [{ text: 'Wow', value: 5 },
      { text: 'Very Good', value: 4 },
      { text: 'Satisfactory', value: 3 },
      { text: 'Not Bad', value: 2 },
      { text: 'Bad', value: 1 }],
  }),
  computed: {
    ...mapGetters(['Feedback']),
    AllAccount: {
      set (value) {
        store.commit('setAllAccount', value);
      },
      get () {
        return store.state.AllAccount;
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.familyList();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    // @vuese
    // Used to go back to the feedback list
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      this.$router.push({ path: '/admin/feedbacks' });
    },
    // @vuese
    // Used to fetch the family list if not exists already
    async familyList () {
      if (!this.AllAccount.length) {
        let populate = [{ 'path': 'human' }, 'contactInfo.country', 'contactInfo.state'];
        let { error, data } = await getCollection('Account', true, 0, populate);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setAllAccount', data);
            this.families();
          }
        }
      } else {
        this.families();
      }
    },
    // @vuese
    // Used to create the contact list from the family list
    async families () {
      this.AllAccount.forEach(item => {
        let obj = {
          text: item.name,
          value: item.id
        };
        this.contactList.push(obj);
      });
    },
    // @vuese
    // Used to save the new feedback
    async save () {
      if (this.$refs.feedbackForm.validate()) {
        if (!this.feedbackData.comment.replace(/(<([^>]+)>)/ig, '').replace(/\s/g, '').length) {
          swal.fire({
            type: 'warning',
            title: 'Content is required.',
            text: 'Please add feeback content before saving!',
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          });
          return;
        }
        this.selectedData = false;
        let postData = { ...this.feedbackData };
        let { error, data } = await create('Feedback', postData);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this.Feedback.unshift(data);
          swal.fire({
            type: 'success',
            title: 'Feedback added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/admin/feedbacks' });
            }
          });
        }
      }
    },
    // @vuese
    // Used to show the form buttons
    changedData () {
      this.selectedData = true;
    },
    // @vuese
    // Used to hide the form buttons
    hideButtons () {
      this.selectedData = false;
    },
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container {
    padding-top: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Feedbacks/add.vue